import { createContext } from 'react';
import type { OnClickFunction } from 'types/html-type';
import type { Debtor } from 'types/store/client-state';
import type { Invoice } from 'types/store/invoice-state';

type InvoiceDetailContextType = {
  data: Invoice;
  isCreditNote: boolean;
  noValidate?: boolean;
  clientData?: Debtor;
  linkCreditNote?: OnClickFunction;
  settleCreditNote?: OnClickFunction;
  unmatchPayment?: VoidFunction;
  reloadInfo: VoidFunction;
};

const InvoiceDetailContext = createContext<InvoiceDetailContextType>(
  {} as InvoiceDetailContextType,
);

export default InvoiceDetailContext;
